import { render, staticRenderFns } from "./groupCreationView.vue?vue&type=template&id=2b3321b5&scoped=true&"
import script from "./groupCreationView.vue?vue&type=script&lang=js&"
export * from "./groupCreationView.vue?vue&type=script&lang=js&"
import style0 from "./groupCreationView.vue?vue&type=style&index=0&id=2b3321b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3321b5",
  null
  
)

export default component.exports